import {
  IHttpService
} from './http.service.interface';
import {HttpError, parseFetchResponse} from "../../../common/utils/parse-fetch-response";



export class HttpService implements IHttpService {
  async get<T = any>(url: string, options?: RequestInit): Promise<T> {
    const fetchedResponse = await this._fetchResponse(url,'GET', options);
    return this._parseResponse(fetchedResponse);
  }

  async post<T = any>(url: string, options?: RequestInit): Promise<T> {
    const fetchedResponse = await this._fetchResponse(url, 'POST', options);
    return this._parseResponse(fetchedResponse);
  }

  createUrlSearchParams(): URLSearchParams {
    return new URLSearchParams();
  }

  createHeaders(): Headers {
    return new Headers();
  }

  async _fetchResponse(url: string, method: string, options?: RequestInit):Promise<Response> {
    options = {...options, method: method};
    const response = await fetch(url, options);

    return response;
  }

  async _parseResponse<T = any>(response: Response):Promise<T> {
    if(!response.ok) {
      throw new HttpError(response);
    }

    return await parseFetchResponse(response);
  }
}
